import { DwModuleType, DwVersionInfo } from "@devwareapps/devware-cap";

export const angularApplicationVersion: DwVersionInfo = {
    ModuleName: 'Fitness-Angular',
    ModuleType: DwModuleType.application,
    ProductVersion: '1.0.11',
    PublishDateTime: '11/04/2026 03:24:41 AM'
}
